import { render, staticRenderFns } from "./OwnerDetails.vue?vue&type=template&id=764149ae&scoped=true"
import script from "./OwnerDetails.vue?vue&type=script&lang=js"
export * from "./OwnerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764149ae",
  null
  
)

export default component.exports